export const ADD_SEAT = 'ADD_SEAT';
export const REMOVE_SEAT = 'REMOVE_SEAT';
export const REMOVE_ALL_SEATS = 'REMOVE_ALL_SEATS';